/* eslint-disable */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/styles";
import Cancel from "@material-ui/icons/CancelPresentationSharp";
import { loadingComponent, notLoadingComponent } from "../../../actions/isLoadingActions";
import "./../styles.css";
import { Box, Card, CardContent, Container, Grid } from "@material-ui/core";
import swalert from "sweetalert";
import { DeleteOutline } from "@material-ui/icons";
import { useMutation } from "@apollo/react-hooks";
import {
  CommercialVarieties_commercialVarieties_edges_node,
  DeleteOneCommercialVariety,
  DeleteOneCommercialVarietyVariables,
} from "../../../data/graphQLModel";
import { MUTATION_DELETE_ONE_COMMERCIAL_VARIETY } from "../../../data/graphQLQueries";
import { MuiThemeProps } from "../../../theme/theme";

const useStyles = makeStyles((theme: MuiThemeProps) => ({
  formControl: {
    margin: theme.spacing(5),
    minWidth: 200,
  },
  form: {
    width: "80%",
  },
  margin: {
    width: "60ch",
    marginBottom: "4ch",
  },
  marginCode: {
    width: "40ch",
    marginBottom: "4ch",
  },
}));

export default function DeleteCommercialVariety() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<CommercialVarieties_commercialVarieties_edges_node[]>();
  const [commVariety, setCommVariety] =
    useState<CommercialVarieties_commercialVarieties_edges_node>();

  const [mutationDeleteOneCommercialVariety] = useMutation<
    DeleteOneCommercialVariety,
    DeleteOneCommercialVarietyVariables
  >(MUTATION_DELETE_ONE_COMMERCIAL_VARIETY);

  const validateimg = () => {
    if (location.state === undefined || !!!location.state[0]) {
      history.push("/customerstables/commvarieties");
      return;
    }
    setCommVariety(location.state[0]);
  };

  useEffect(() => {
    validateimg();
  }, []);

  async function submitForm(e: any) {
    e.preventDefault();

    dispatch(loadingComponent());

    try {
      var res = await mutationDeleteOneCommercialVariety({
        variables: {
          input: {
            id: commVariety?.id as string,
          },
        },
      });
      if (res) swalert("Success.", "Variety delete with success", "success");
    } catch (err: any) {
      dispatch(notLoadingComponent());
      let errorString =
        err?.message +
        "; " +
        err?.clientErrors?.map((el: any) => el?.message).join("; ") +
        err?.graphQLErrors?.map((el: any) => el?.message).join("; ");
      swalert("Failed.", errorString, "error");
      return;
    }
    dispatch(notLoadingComponent());
    history.push("/customerstables/commvarieties");
  }

  function handleCancel(event: any) {
    event.preventDefault();
    history.push("/customerstables/commvarieties");
  }

  // console.log(variety)
  return commVariety ? (
    <div className="container">
      <Container style={{ marginTop: "70px" }}>
        <Box style={{ marginBottom: "10px" }}>
          <Card>
            <CardContent>
              <h2 style={{ marginBottom: "-10px" }}>Delete Commercial Varieties</h2>
            </CardContent>
          </Card>
        </Box>
        <hr />
        <Card>
          <CardContent>
            <form className={classes.form} onSubmit={submitForm} style={{ width: "100%" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box>
                  <FormControl className={classes.margin} variant="outlined">
                    <TextField
                      id="code"
                      label="Code"
                      name="code"
                      placeholder="Code"
                      disabled
                      focused
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      value={commVariety.code}
                    />
                  </FormControl>
                  <div>
                    <FormControl className={classes.margin} variant="outlined">
                      <TextField
                        id="description"
                        label="Description"
                        name="description"
                        placeholder="Description"
                        disabled
                        InputLabelProps={{
                          shrink: true,
                        }}
                        multiline
                        variant="outlined"
                        value={commVariety.description}
                      />
                    </FormControl>
                  </div>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", marginLeft: 10 }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid item xs={12}>
                      <FormControl className={classes.margin} variant="outlined">
                        <TextField
                          disabled
                          label="Material Type"
                          name="materialtype"
                          variant="outlined"
                          value={commVariety?.materialtype?.description?.pt}
                          title="Material Type"
                        />
                      </FormControl>
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid item xs={12}>
                      <FormControl className={classes.margin} variant="outlined">
                        <TextField
                          disabled
                          label="System Variety"
                          name="system_variety"
                          variant="outlined"
                          value={commVariety?.system_variety?.normativedesig}
                          title="System Variety"
                        />
                      </FormControl>
                      {commVariety.system_variety && (
                        <Grid container spacing={2} xs={8}>
                          <Grid item md={6} xs={12}>
                            <TextField
                              id="alternativedesig"
                              label="Alternative Design"
                              value={commVariety?.system_variety?.alternativedesig}
                              placeholder="Alternative Design"
                              disabled
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <TextField
                              id="normativedesig"
                              label="Normative Desig"
                              value={commVariety?.system_variety?.normativedesig}
                              placeholder="Normative Desig"
                              disabled
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <TextField
                              id="districtquarry"
                              label="District Quary"
                              value={commVariety?.system_variety?.districtquarry}
                              placeholder="District Quary"
                              disabled
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Box>
              </Box>
              <div className="btnform" style={{ justifyContent: "space-between", width: "100%" }}>
                <div>
                  <FormControl fullWidth style={{ margin: "15px" }} variant="outlined">
                    <Button
                      onClick={handleCancel}
                      fullWidth
                      variant="contained"
                      style={{ height: "50px", width: "200px", fontSize: "20px" }}
                    >
                      Cancel
                      <Cancel style={{ marginLeft: "20px" }} />
                    </Button>
                  </FormControl>
                </div>
                <div>
                  <FormControl fullWidth variant="outlined" style={{ margin: "15px" }}>
                    <Button
                      onClick={submitForm}
                      type="submit"
                      fullWidth
                      variant="contained"
                      style={{ height: "50px", width: "200px", fontSize: "20px" }}
                      color="secondary"
                    >
                      Delete
                      <DeleteOutline style={{ marginLeft: "20px" }} />
                    </Button>
                  </FormControl>
                </div>
              </div>
            </form>
          </CardContent>
        </Card>
      </Container>
    </div>
  ) : (
    <div></div>
  );
}
